<template>
  <vx-card>
    <h4 class="mb-5">1. Induction</h4>
    <p class="mb-5">
      Welcome to your virtual work experience induction for secondary school teaching! Through this
      experience you will get a taste for the theories and practices involved in being a great
      teacher.
    </p>
    <p class="mb-5">
      Being a teacher is considered to be one of the most fulfilling and rewarding careers out
      there, as you’re able to make a big difference to your students’ lives.
    </p>
    <p class="mb-5">In this experience, we will go through:</p>

    <ul class="default-list">
      <li>The different kinds of secondary school teachers</li>
      <li>What qualifications you need to get started as a teacher</li>
      <li>Some of the theories and tools teachers use to create great lessons for students</li>
      <li>Some exercises you can do to get a taste of what it’s like to be a teacher.</li>
    </ul>

    <p class="mb-5">Let’s dive in!</p>

    <div class="vx-row mt-10 mb-5">
      <div class="vx-col xl:w-2/3 w-full my-5">
        <responsive-iframe-youtube :src="video.url" :posterimg="video.image" />
      </div>
    </div>

    <h4 class="mb-5">Resources</h4>

    <vs-list>
      <vs-list-item
        title="Induction Sheet"
        subtitle="An overview of what is expected of you and the rules you must follow."
      >
        <vs-button
          color="success"
          type="gradient"
          href="https://www.careertools.com.au/vje/content/nurse/induction_sheet_nursing.pdf"
          target="_blank"
          >Download</vs-button
        >
      </vs-list-item>
    </vs-list>
  </vx-card>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    video() {
      return {
        //url: 'https://www.careertools.com.au/vje/content/' + this.experience.vje.folder_name.toLowerCase() + '/virtual_tour.mp4',
        url: 'https://www.youtube.com/embed/EM1iP3iHhKE',
        image: require('@/assets/images/experiences/' +
          this.experience.vje.folder_name.toLowerCase() +
          '/virtual_tour.jpg'),
      };
    },
  },
};
</script>
